import React, { Component } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { ReactComponent as BoothTrafficIcon } from "../../../images/icon/boothTraffic.svg";
import { ReactComponent as EngagementIcon } from "../../../images/icon/engagement.svg";
import { ReactComponent as InsightsIcon } from "../../../images/icon/insights.svg";
const renderBoothTrafficSlide = () => (
  <div className="slider-item">
    <div className="conferences-card">
      <div className="feature-container conference-bx2 feature1">
        <span className="icon-cell">
          <BoothTrafficIcon />
        </span>
        <div className="icon-content">
          <h3 className="ttr-title">Drive booth traffic</h3>
          <p>
            Engage attendees during the conference to boost booth visits and
            interaction.
          </p>
        </div>
      </div>
    </div>
  </div>
);

const renderOngoingEngagementSlide = () => (
  <div className="slider-item">
    <div className="conferences-card">
      <div className="feature-container conference-bx2 feature2">
        <span className="icon-cell">
          <EngagementIcon />
        </span>
        <div className="icon-content ">
          <h3 className="ttr-title">Ongoing engagement</h3>
          <p>
            Continue delivering your message for up to 30 days after the
            conference, keeping your brand top of mind.
          </p>
        </div>
      </div>
    </div>
  </div>
);

const renderInsightsSlide = () => (
  <div className="slider-item">
    <div className="conferences-card">
      <div className="feature-container conference-bx2 feature3">
        <span className="icon-cell">
          <InsightsIcon />
        </span>
        <div className="icon-content">
          <h3 className="ttr-title">Actionable Insights</h3>
          <p>
            Track and analyze results using Physician Level Data (PLD), turning
            your digital strategy into actionable lead generation.
          </p>
        </div>
      </div>
    </div>
  </div>
);

class HCPConferencesSliderSection extends Component {
  render() {
    const settings = {
      dots: true,
      autoplay: true,
      duration: 500,

      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 591,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };

    return (
      <section className="section-sp2">
        {" "}
        <h3 className="title-ext text-secondary text-center mb-30">
          Benefits of Conference Geofencing
        </h3>
        <div className="section-area section-sp1 conference-wrapper-main-page">
          <div
            className="row align-items-center"
            style={{
              display: "flex",
              alignItems: "stretch",
              justifyContent: "center",
            }}
          >
            <div className="col-xl-8 mb-15 ">
              <Slider {...settings} className="service-slide slick-arrow-none">
                {renderBoothTrafficSlide()}
                {renderOngoingEngagementSlide()}
                {renderInsightsSlide()}
                {renderBoothTrafficSlide()}
                {renderOngoingEngagementSlide()}
                {renderInsightsSlide()}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default HCPConferencesSliderSection;
